import React from "react";
import "../styles/App.css";



function Spinner() {

    return (
        <div className="overlay">
            <div className="spinner"></div>
        </div>
    );
}



export default Spinner;